import type * as yup from 'yup';

import { isWholeNumber } from '@/shared/validators';

import { MAX_COVERAGE_MONTHS } from './lease-form.constraints';

export const overrideRentSchema = (
  schema: yup.StringSchema<string | undefined, yup.AnyObject, undefined, ''>,
) =>
  schema
    .required('Rent coverage is required')
    .test('valid-coverage', 'Please enter a valid coverage amount', (value) => {
      if (!value) {
        return true;
      }
      if (!isWholeNumber(value)) {
        return false;
      }
      const parsed = Number.parseInt(value, 10);
      return !Number.isNaN(parsed) && parsed >= 0 && parsed <= MAX_COVERAGE_MONTHS;
    });
